import { FunctionComponent } from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useNavigate } from 'react-router-dom';

// Soft sage-grey that echoes the navbar's teal without repeating it.
const FooterContainer = styled('footer')(({ theme }) => ({
  backgroundColor: '#E3E9E5',
  color: '#3A4644',
  borderTop: '3px solid #0C4A4A',
  '& h6': {
    color: '#0C4A4A',
  },
  padding: theme.spacing(4, 0),
  marginTop: 'auto',
}));

const FooterSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const FooterLink = styled(Button)(({ theme }) => ({
  color: '#3A4644',
  textDecoration: 'none',
  display: 'block',
  marginBottom: theme.spacing(1),
  textTransform: 'none',
  justifyContent: 'flex-start',
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },
}));

const Footer: FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <FooterContainer>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <FooterSection>
              <Typography variant="h6" gutterBottom>
                Contact Us
              </Typography>
              <Typography variant="body2">
                9191 Daly Rd.<br />
                Cincinnati Ohio 45321<br />
                Phone: (513) 755-0040
              </Typography>
            </FooterSection>
            <FooterSection sx={{ mt: 3 }}>
              <Typography variant="h6" gutterBottom>
                Donations
              </Typography>
              <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input type="hidden" name="hosted_button_id" value="PL5PNUL9M2ZCC" />
                <input
                  type="image"
                  src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
                  name="submit"
                  alt="PayPal - The safer, easier way to pay online!"
                />
                <img alt="" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
              </form>
            </FooterSection>
          </Grid>

          <Grid item xs={12} sm={4}>
            <FooterSection>
              <Typography variant="h6" gutterBottom>
                Quick Links
              </Typography>
              <FooterLink onClick={() => navigate('/')}>
                Home
              </FooterLink>
              <FooterLink onClick={() => navigate('/about-us')}>
                About Us
              </FooterLink>
              <FooterLink onClick={() => navigate('/visitors')}>
                Visitors
              </FooterLink>
              <FooterLink onClick={() => navigate('/streaming')}>
                Live Stream
              </FooterLink>
              <FooterLink onClick={() => navigate('/announcements')}>
                Announcements
              </FooterLink>
            </FooterSection>
          </Grid>

          <Grid item xs={12} sm={4}>
            <FooterSection>
              <Typography variant="h6" gutterBottom>
                Connect With Us
              </Typography>
              <Box>
                <Button
                  component="a"
                  href="https://www.facebook.com/groups/cogcincinnati/?ref=share&mibextid=NSMWBT"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  sx={{
                    color: '#0C4A4A',
                    marginRight: 1,
                    minWidth: 'auto',
                    padding: 1,
                    '&:hover': {
                      backgroundColor: 'rgba(12, 74, 74, 0.08)',
                    },
                  }}
                >
                  <FacebookIcon />
                </Button>
              </Box>
              <Typography variant="body2" sx={{ mt: 2 }}>
                Follow us on social media for updates and inspiration
              </Typography>
            </FooterSection>
          </Grid>
        </Grid>

        <Box sx={{ mt: 4, pt: 2, borderTop: '1px solid rgba(12, 74, 74, 0.15)' }}>
          <Typography variant="body2" align="center">
            © {new Date().getFullYear()} Church of God Cincinnati. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
